<template>
  <div class="warp ">

    <navBox :page="'HomePage'" @scrollToBottom='scrollToBottom'></navBox>

    <!-- 第一张海报 -->
    <div class="first_box media_box">
      <div class="pic">
        <img :src="image1" alt="" />
      </div>
      
      <div class="first_desc">
        <div class="big_title">约剑 一站式赛事平台</div>
        <div class="title_desc normal_font">
          告别办赛难、开赛难、参赛难，轻松解决赛事问题
        </div>
        <div class="to_detail MiSansRegular_font">了&#8194;解&#8194;详&#8194;情</div>
      </div>
      <div></div>
    </div>

    <div class="bg_line"></div>

    <!-- 第二张海报 -->
    <div class="sec_box media_box ">
      <div class="pic">
        <img :src="image2" alt="" />
      </div>
      <div class="sec_desc">
        <div class="sm_desc normal_font">快速 | 简单 | 高效</div>
        <div class="big_title">击剑赛事的一站式解决方案</div>
        <div class="get_detail">
          <div class="left_border"></div>
          <div class="text MiSansLight_font">了&#8194;解&#8194;详&#8194;情&#8194;></div>
          <div class="right_border"></div>
        </div>
      </div>
    </div>

    <!-- 第三张海报 -->
    <div class="third_box media_box">
      <div class="pic">
        <img :src="image3" alt="" />
      </div>
      <div class="third_content">
        <div>
          <div style='display: flex;'>
            <div class="data_num hum_din">35000</div>
            <div class="add">
              <img src="https://img.fencerspage.com/upload/oss/club/contest/20240613/2331666a9063d0a65.png" alt="">
            </div>
          </div>
          <div class="data_title MiSansRegular_font">用户总数</div>
        </div>
        <div>
          <div style='display: flex;'>
            <div class="data_num hum_din">85%</div>
            <div class="add">
              <img src="https://img.fencerspage.com/upload/oss/club/contest/20240613/2331666a9063d0a65.png" alt="">
            </div>
          </div>
          <div class="data_title MiSansRegular_font">省内主办方合作选择</div>
        </div>
        <div>
          <div style='display: flex;'>
            <div class="data_num hum_din">150</div>
            <div class="add">
              <img src="https://img.fencerspage.com/upload/oss/club/contest/20240613/2331666a9063d0a65.png" alt="">
            </div>
          </div>
          <div class="data_title MiSansRegular_font">一年举办击剑赛事数量</div>
        </div>
      </div>
    </div>

    <div class="bg_line"></div>

    <!-- 第四张海报 -->
    <div class="four_box media_box">
      <div class="pic">
        <img :src="image4" alt="" />
      </div>
      <div class="four_desc">
        <div class="title">约剑优势</div>
        <div class="title">智能报名、编排系统</div>
        <div class="get_detail">
          <div class="left_border"></div>
          <div class="text MiSansLight_font">了&#8194;解&#8194;详&#8194;情&#8194;></div>
          <div class="right_border"></div>
        </div>
      </div>

    </div>

    <!-- 第五张海报 -->
    <div class="five_box media_box">
      <div class="pic">
        <img :src="image5" alt="" />
      </div>
      <div class="five_desc">
        <div class="title">约剑优势</div>
        <div class="title">小程序同步赛事进程</div>
        <div class="get_detail">
          <div class="left_border"></div>
          <div class="text MiSansLight_font">了&#8194;解&#8194;详&#8194;情&#8194;></div>
          <div class="right_border"></div>
        </div>
      </div>
      <div class="five_show">
        <div class="show_title MiSansRegular_font">案例展示</div>
        <div class="show_content MiSansRegular_font">
          <div class="show_item" v-for="(item,index) in showList" :key="index">
            {{ item.content }}
          </div>
        </div>
      </div>
    </div>

    <div class="bg_line"></div>

    <!-- 第六张海报 -->
    <div class="six_box media_box">
      <div class="pic">
        <img :src="image6" alt="" />
      </div>
      <div class="six_desc">
        <div class="title">技术优势</div>
        <div class="title">定制服务、创新迭代</div>
        <div class="get_detail">
          <div class="left_border"></div>
          <div class="text MiSansLight_font">了&#8194;解&#8194;详&#8194;情&#8194;></div>
          <div class="right_border"></div>
        </div>
      </div>
    </div>

    <!-- 第七张海报 -->
    <div class="seven_box media_box">
        <div class="left">
          <div class="seve_title">加入约剑</div>
          <div class="seven_desc medium_font">联系电话：+86 13316113801</div>
          <div class="seven_desc medium_font">联系邮箱：winkid@fencerpage.com</div>
          <div class="privacy_text" @click="goPage('/PrivacyPage')">隐私协议</div>
        </div>
        <div class="bottom">
          <!-- <img :src="logo" alt=""> -->
          <div class="seven_text">
            <a class="medium_font" target="_blank"  href="https://beian.miit.gov.cn/#/Integrated/index">
              Copyright © 广州约剑汇体育科技有限公司 版权所有 粤ICP备2022142771号</a>
            <!-- <div class="medium_font" style="margin-top: 0.2vw;">Copyrighte2008-2023尊云|简单好用的云服务器(ww.zun.com) 广东尊云网络科技有限公司</div> -->
          </div>
        </div>

        <div class="right" >
          <div class="other_logo">
            <img class="xhs" :src="platformList[0].img" alt="">
            <img class="bilibili" :src="platformList[1].img" alt="">
            <img class="douyin" :src="platformList[2].img" alt="">
            <img class="youtube" :src="platformList[3].img" alt="">
            <img class="xhs" :src="platformList[4].img" alt="">
          </div>
          <div class="qrCode">
            <div class="code_item" v-for="item in qrCodeList" :key="item.id">
              <div class="code_image"><img :src="item.image" alt=""></div>
              <div class="code_content">{{ item.content }}</div>
            </div>
          </div>
        </div>
        
        <div class="bottom_right">
          <div class="normal_font" @click="scrollToTop">
            <img class="arrow_top" src="https://img.fencerspage.com/upload/oss/club/contest/20241129/2701674988e5cbee9.png" alt="">
            <div>回到顶部</div>
          </div>
        </div>
    </div>

     <!-- 右侧咨询 -->
    <div class="suspend">
      <!-- href="https://work.weixin.qq.com/kfid/kfca0d93152e2abb05e" -->
      <!-- <a href="/" 
        target="_blank"  
        class="suspend_box" 
        @mouseover="hover1=true" 
        @mouseleave="hover1=false"
      > -->
      <!-- <div class="suspend_box"  @mouseover="hover1=true" @mouseleave="hover1=false">
        <div class="suspend_img"><img :src="pictureHover1"  alt=""></div>
        <div class="suspend_content">立刻咨询</div>
      </div> -->
      <!-- </a> -->
      <div class="suspend_box" @mouseover="hover2=true" @mouseleave="hover2=false">
        <div class="suspend_img"><img :src="pictureHover2" alt=""></div>
        <div class="suspend_content">扫码咨询</div>
        <div class="showCode" v-show="hover2">
          <!-- v-show="hover2" -->
          <div class="ser_img"><img :src="service_code" alt=""></div>
          <div class="ser_content">约剑微信客服</div>
          <div class="right_arrow"></div>
        </div>
      </div>
    </div>
  </div>

 
</template>

<script>
import navBox from '@/components/navBox.vue';
export default {
  components: { navBox },
  name: "HomeComponent",
  props: {},
  data() {
    return {
      showList:[
        {id:1,content:'《2023年粤港澳大湾区击剑比赛》'},
        {id:2,content:'《2024年“世承杯”击剑精英选拔赛(第一站)》'},
        {id:3,content:'《2023年辽宁省青少年击剑冠军系列赛第二站》'},
        {id:4,content:'《2024年“奔跑吧.少年”海南省青少年体育联赛暨海南省青少年击剑系列赛(琼海站)》'},
      ],
      platformList:[
        {id:1,img:'https://img.fencerspage.com/upload/oss/club/contest/20240528/55226655398ae6cd4.png'},
        {id:2,img:'https://img.fencerspage.com/upload/oss/club/contest/20240528/173566553ebfcd016.png'},
        {id:3,img:'https://img.fencerspage.com/upload/oss/club/contest/20240528/174666553ecae17bf.png'},
        {id:4,img:'https://img.fencerspage.com/upload/oss/club/contest/20240528/114866554b74d6974.png'},
        {id:5,img:'https://img.fencerspage.com/upload/oss/club/contest/20240528/182366553eefdff2b.png'},
      ],
      image1:
        "https://img.fencerspage.com/upload/oss/club/contest/20240522/4915664d875bb7b56.jpg",
      image2:
        "https://img.fencerspage.com/upload/oss/club/contest/20240523/3919664f0ec78d038.jpg",
      image3:'https://img.fencerspage.com/upload/oss/club/contest/20240524/113266504bb4ec9cc.jpg',
      image4:'https://img.fencerspage.com/upload/oss/club/contest/20240524/143866504c6e6121f.jpg',
      image5:'https://img.fencerspage.com/upload/oss/club/contest/20240524/150666504c8a9aae8.jpg',
      image6:'https://img.fencerspage.com/upload/oss/club/contest/20240524/152166504c99a20c0.jpg',
      qrCodeList:[
        {id:1,content:'应用下载',image:'https://img.fencerspage.com/upload/oss/club/contest/20250124/1031679359075ac3d.png'},
        {id:2,content:'约剑小程序',image:'https://img.fencerspage.com/upload/oss/club/contest/20240611/06116667e953d98a7.jpg'},
        {id:3,content:'扫一扫关注公众号',image:'https://img.fencerspage.com/upload/oss/club/contest/20240611/06506667e97a5100c.jpg'}
      ],
      wxPNG:"https://img.fencerspage.com/upload/oss/club/contest/20240611/04366667f70436d6e.png",
      wxPNG_hover:"https://img.fencerspage.com/upload/oss/club/contest/20240611/25526667fc004bf09.png",
      service_code:"https://img.fencerspage.com/upload/oss/club/contest/20240611/522566680239233ce.png",
      hover1:false,
      hover2:false,
    };
  },

  mounted(){
    if(this.$route.query.pageForm =='secondary'){
      this.scrollToBottom()
    }
  },

  computed: {
    pictureHover1() {
      if (this.hover1 == true) {
        return this.wxPNG_hover
      } else {
        return this.wxPNG
      }
    },
    pictureHover2() {
      if (this.hover2 == true) {
        return this.wxPNG_hover
      } else {
        return this.wxPNG
      }
    }
  },

  methods:{
    goPage(url){
      this.$router.push({ path: url})
    },

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },

    scrollToBottom() {
      window.scrollTo({
          top: document.body.scrollHeight,
          behavior: 'smooth'
      });
    },

    // 跳转到其他页面
    goToExternalPage(url){
        window.location.href = url;
    },

  }
};
</script>

<style scoped  lang="scss">
$media_num: 1200px;  // 屏幕宽度

a{
  text-decoration: none;
  cursor: pointer;
  outline: 0;
  color: #2c3e50;
}

img {
  width: 100%;
  height: 100%;
}

.warp {
  margin: 0 auto;
  width: 100vw;
}

.pic {
  width: 100%;
  height: 100%;
}

.media_box{
  width: 100vw;
  height: 50vw;
  font-size: 0.88vw; //17

  @media only screen and (max-width: $media_num) {
    width: 1200px;
    height:600px;  // 0.5*width
    // height: calc(var($media_num)*0.5); // 0.5*width
    font-size:10.6px; // 0.00885*$media_num
  }
}

.bg_line{
  width: 100%;
  height: 0.83vw;

  @media only screen and (max-width: $media_num) {
    height:9px;  // 0.0075*$media_num
  }
}

// .nav{
//   width: 100vw;
//   height: 4vw;
//   position: relative;
//   // background-color: #000;
//   background-color: #000;
//   position: fixed;
//   left: 0;
//   top: 0;
//   z-index: 999;

//   @media only screen and (max-width: $media_num) {
//     height:50px; // 0.46*$media_num
//     width: 1200px;
//     font-size:10.6px; 
//   }

//     .first_top {
//       height: 100%;
//       width: 70%;
//       // height: 11%;
//       // width: 73%;
//       // background-color: pink;
      
//       display: flex;
//       align-items: center;


//       .logo {
//         width: 2.6%; //31
//         height: 48%; //34
//         margin-left: 10%; //125
//         margin-right: 20%;
//       }

//       .title {
//         display: flex;

//         .sm_title {
//           cursor: pointer;
//           font-size: 1em; //17
//           font-weight: 700;
//           color: #fff;
//           // margin-left: 2em; //50
//           margin-left: 2.8em; //50
//         }
//       }
//     }
//   }

.first_box {
  height: 40vw;
  position: relative;

  @media only screen and (max-width: $media_num) {
    height:480px; // 0.46*$media_num
  }

  .first_desc {
    position: absolute;
    right: 10%; //127px;
    top: 30%; //276px;
    color: #fff;

    .big_title {
      // font-size: 4.9vw; //94px;
      font-size: 5.5em; //94px;
      font-weight: 700;
      font-family:'MiSansDemiBold', sans-serif;
    }

    .title_desc {
      font-size: 1.8em; //30px;
      margin-top: 4%; // 40px;
    }

    .to_detail {
      margin: 0 auto;
      width: 23%; // 417px;
      font-size: 2.1em; //38px;
      margin-top: 9.4%; // 83px;
      padding: 0.5em 2.75em; //18px 100px ;
      border: 0.05em solid #fff;
      cursor: pointer;
    }
  }
}

.sec_box{
  position: relative;
  text-align:left;

  .sec_desc{
    position: absolute;
    left: 8.4% ; //161px
    top: 12.5%; // 120px
    color: #fff;

    .sm_desc{
      font-size: 1.77em; // 30
      letter-spacing:0.27em;
    }

    .big_title {
      font-size: 3.9em; //67px;
      font-weight: 700;
      margin-top: 0.64em ; //41
      font-family:'MiSansDemiBold', sans-serif;
    }
  }
}

.third_box{
  position: relative;

  .third_content{
    box-sizing: border-box;
    height: 100%;
    text-align: left;
    position: absolute;
    right: 9.8%;
    top: 0;
    color: #3c3c3c;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 8.9em 0;
    font-weight: 700;


    .add{
      position: relative;
      // background-color: pink;
      margin-left: 1.4em;
      width: 2.4em;
      height: 2.4em;
    }

    .data_num{
      font-size:5.1em;
    }

    .data_title{
      font-size:1.6em ;
      margin-top: 0.5em;
      margin-left: 0.1em;
    }

  }
}

.four_box{
  position: relative;

  .four_desc{
    text-align: right;
    color: #fff;
    position: absolute;
    top: 14%;
    right: 7.8%;

    .title{
      font-weight: 700;
      font-size:3.9em;
      margin-top: 0.5em;
      // letter-spacing:0.4vw;
      font-family:'MiSansDemiBold', sans-serif;
    }

    .get_detail{
      position: absolute;
      right: 5%;
    }
  }

}

.five_box{
  position: relative;
                                                                                                                   
  .five_desc{
    text-align: left;
    color: #fff;
    position: absolute;
    top: 14%;
    left: 7.8%;

    .title{
      font-weight: 700;
      font-size:4em;
      margin-top: 0.5em;
      // letter-spacing:0.4vw;
      font-family:'MiSansDemiBold', sans-serif;
    }
  }

  
  .five_show{
    text-align: left;
    width:26%;
    position: absolute;
    bottom: 14.6%;
    right: 2% ;

    .show_title{
      font-size: 1.92em;
      font-weight: 700;
      font-family:'MiSansDemiBold', sans-serif;
    }
 
    .show_content{
      margin-top: 3.4em;
      font-size: 1.14em;


      .show_item{
        line-height: 2em;
      }

    }
  }
}

.six_box{
  position: relative;

  .six_desc{
    text-align: right;
    color: #fff;
    position: absolute;
    top:14%;
    right: 7.8%;

    .title{
      font-weight: 700;
      font-size:4em;
      margin-top: 0.52em;
      // letter-spacing:0.4vw;
      font-family:'MiSansDemiBold', sans-serif;
    }

    .get_detail{
      position: absolute;
      right: 5%;
    }
  }
}

.seven_box{
  height: 37.3vw;
  position: relative;
  background-color: #f5f5f5;
  color: #000;

  @media only screen and (max-width: $media_num) {
    height:444px; // 0.37*$media_num
  }

  .left{
    position: absolute;
    left: 9%;
    top: 12.8%;
    text-align: left;
    font-weight: 700;

    .seve_title{
      font-size:4em;
      margin-bottom: 1.5em;
      font-family:'MiSansDemiBold', sans-serif;
      font-weight: 700;
    }

    .seven_desc{
      font-size:1.5em ;
      margin-bottom:0.6em;
    }

    .privacy_text{
      font-size:1.3em ;
      cursor: pointer;
    }
  }

  .bottom{
    position: absolute;
    bottom:11%;
    left: 50%;
    transform: translate(-50%);
    display: flex;

    // img{
    //   width: 3vw;
    //   height: 3vw;
    // }

    .seven_text{
      text-align: left;
      font-size: 1em;
      cursor: pointer;
    }
  }

  .right{
      position: absolute;
      top: 21.2%;
      right: 5.2%;
      width:33%;
      /* background-color: pink; */

      .other_logo{
        display: flex;
        justify-content: flex-end;
        width:  100%;
      }
  
      img{
        height: 2.3em;
        width:  2.36em;
      }
  
      .bilibili{
        width: 8em;
        margin-left: 1.7em;
        margin-top: 0.3em;
      }
  
      .douyin{
        width: 5.65em;
        height: 2.5em;
        margin-left: 1.7em;
      }
  
      .youtube{
        width: 6.85em;
        height: 1.7em;
        margin-left: 1.7em;
        margin-right:1.7em;
        margin-top: 0.8em;
      }
  
      .xhs{
        margin-top: 0.3em;
        margin-right:0.5em;
      }
  
      .qrCode{
        width: 100%;
        height: 100%;
        margin-top: 3.5em;
        display: flex;
        justify-content: space-between;
  
        .code_item{
  
          .code_image{
            width: 11.3em;
            height: 11.3em;
  
            img{
              width: 100%;
              height: 100%;
            }
          }
  
          .code_content{
            font-size: 1.15em;
            margin-top: 1em;
            text-align: center;
          }
        }
      }
    }

  .bottom_right{
    display: flex;
    position: absolute;
    right: 3.5%;
    bottom: 13%;
    color: #6c6c6c;
    font-size: 1.05em;
    cursor: pointer;

    .normal_font{
      display: flex;

      .arrow_top{
          width:  1.5em;
          height:  1.5em;
        }
    }

   
  }
}


.get_detail {
      position: relative;
      font-size: 1.45em; //24px;
      margin-top: 4.85em; // 120px;
      margin-left: 1.2em;
      width: 7.9em; // 194px;
      cursor: pointer;

    .text{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 2.2em ; //40px
      width: 7.9em; // 194px;
      position: absolute;
      left: 0;
      top: 0;
      border-top: 0.05em solid #fff;
      border-bottom: 0.05em solid #fff;
    }

    .left_border{
        position: absolute;
        left: 0;
        top: 0;
        transform: translate(-50%,0);
        width: 2em;
        height:  2.2em;
        border:0.05em solid #fff;
        border-right:0;
        border-radius:50% 0 0 50%; 
      }

    .right_border{
        position: absolute;
        right: 0;
        top: 0;
        transform: translate(50%,0);
        width: 2em;
        height:  2.2em;
        border:0.05em solid #fff ;
        border-left:0;
        border-radius:0 50% 50% 0; 
      }
    }

.suspend{
  // width: 6.5em;
  // height: 6.5em;
  position: fixed;
  right: 15px;
  bottom: 41%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: pink;

  .suspend_box{
    position: relative;
    background-color: #fff;
    box-shadow: 0 0 0.5em 0.1em #6c6c6c7d;
    border-radius: 3%;
    width: 4.5em;
    height: 4.5em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;


    .suspend_img{
      width: 2em;
      height: 2em;
    }
    .suspend_content{
      font-size: 0.5em;
      margin-top: 0.2em;
    }

    .showCode{
      position: absolute;
      right: 100%;
      top:50%;
      transform: translateY(-50%);
      width: 10em;
      height: 10em;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 2em;
      box-shadow: 0 0 0.6em 0.1em #6c6c6c7d;
      // justify-content: center;

      .ser_img{
        margin-top: 0.6em;
        width: 7.8em;
        height: 7.8em;
      }

      .ser_content{
        font-size: 0.7em;
        margin-top: 0.3em;
        color: #2c3e50;
      }

      .right_arrow{
        position: absolute;
        right: 0;
        top: 50%;
        transform: rotate(45deg) translate(25%,-50%);
        // translate(50%,-50%)
        width:0.6em;
        height: 0.6em;
        background-color: #fff;
        // box-shadow: 0 0 0.6em 0.1em #6c6c6c7d;
      }

      
    }
  }

  .suspend_box:hover{
    color: #059fff;
  }
}



</style>
